var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcRatings = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_ratings",
  transform: "translate(0 24)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_349",
  "data-name": "Rectangle 349",
  width: 34,
  height: 34,
  transform: "translate(0 -24)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Path_378",
  "data-name": "Path 378",
  transform: "translate(9 -23)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.792,5.034,7.895,0l2.173,4.96,5.418.536-4.1,3.637,1.254,5.308L7.931,11.663l-4.672,2.7,1.2-5.3L.365,5.5Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 7.916651725769043 2.542123794555664 L 6.714504241943359 5.419918060302734 L 6.480753898620605 5.979477882385254 L 5.876534461975098 6.030868530273438 L 2.805999755859375 6.292052268981934 L 5.119174003601074 8.301938056945801 L 5.571014404296875 8.694538116455078 L 5.438454627990723 9.278258323669434 L 4.740781784057617 12.35029411315918 L 7.430704116821289 10.79661846160889 L 7.936354160308838 10.50455856323242 L 8.439214706420898 10.80139827728271 L 11.12389945983887 12.38620090484619 L 10.40948486328125 9.362758636474609 L 10.27202415466309 8.781007766723633 L 10.71933364868164 8.384488105773926 L 13.10914897918701 6.266016960144043 L 9.969314575195312 5.955588340759277 L 9.386653900146484 5.897977828979492 L 9.151723861694336 5.361668586730957 L 7.916651725769043 2.542123794555664 M 7.894834518432617 -1.9073486328125e-06 L 10.06770420074463 4.96043872833252 L 15.48523426055908 5.496058464050293 L 11.3826847076416 9.132798194885254 L 12.63686466217041 14.44055843353271 L 7.930864334106445 11.66254806518555 L 3.258634567260742 14.36118793487549 L 4.463284492492676 9.056798934936523 L 0.365234375 5.496058464050293 L 5.791774749755859 5.034468650817871 L 7.894834518432617 -1.9073486328125e-06 Z",
  stroke: "none",
  fill: "#5f7278"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_379",
  "data-name": "Path 379",
  transform: "translate(1 -14)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4,3.37,5.4,0,6.859,3.32l3.626.358L7.739,6.113l.839,3.553L5.429,7.806,2.3,9.612l.806-3.55L.365,3.679Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 5.422338485717773 2.033694267272949 L 4.735464096069336 3.677989959716797 L 4.548474311828613 4.125630378723145 L 4.065084457397461 4.166749954223633 L 2.317841529846191 4.315374374389648 L 3.632814407348633 5.457940101623535 L 3.994294166564941 5.772029876708984 L 3.88823413848877 6.23900032043457 L 3.487532138824463 8.003410339355469 L 5.028884410858154 7.113140106201172 L 5.433394432067871 6.879500389099121 L 5.835684299468994 7.116970062255859 L 7.368411064147949 8.021755218505859 L 6.960784435272217 6.296660423278809 L 6.850814342498779 5.831260204315186 L 7.208664417266846 5.514039993286133 L 8.584362030029297 4.29454517364502 L 6.78050422668457 4.116199970245361 L 6.314374446868896 4.070110321044922 L 6.126434326171875 3.641070365905762 L 5.422338485717773 2.033694267272949 M 5.404884338378906 0 L 6.859214305877686 3.320080280303955 L 10.48523426055908 3.678580284118652 L 7.739344596862793 6.112689971923828 L 8.578783988952637 9.665240287780762 L 5.429004192352295 7.805890083312988 L 2.301824569702148 9.612119674682617 L 3.108104228973389 6.061830043792725 L 0.365234375 3.678580284118652 L 3.997284412384033 3.369630336761475 L 5.404884338378906 0 Z",
  stroke: "none",
  fill: "#5f7278"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_380",
  "data-name": "Path 380",
  transform: "translate(22 -14)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4,3.37,5.4,0,6.859,3.32l3.626.358L7.739,6.113l.839,3.553L5.429,7.806,2.3,9.612l.806-3.55L.365,3.679Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 5.422338485717773 2.033694267272949 L 4.735464096069336 3.677989959716797 L 4.548474311828613 4.125630378723145 L 4.065084457397461 4.166749954223633 L 2.317841529846191 4.315374374389648 L 3.632814407348633 5.457940101623535 L 3.994294166564941 5.772029876708984 L 3.88823413848877 6.23900032043457 L 3.487532138824463 8.003410339355469 L 5.028884410858154 7.113140106201172 L 5.433394432067871 6.879500389099121 L 5.835684299468994 7.116970062255859 L 7.368411064147949 8.021755218505859 L 6.960784435272217 6.296660423278809 L 6.850814342498779 5.831260204315186 L 7.208664417266846 5.514039993286133 L 8.584362030029297 4.29454517364502 L 6.78050422668457 4.116199970245361 L 6.314374446868896 4.070110321044922 L 6.126434326171875 3.641070365905762 L 5.422338485717773 2.033694267272949 M 5.404884338378906 0 L 6.859214305877686 3.320080280303955 L 10.48523426055908 3.678580284118652 L 7.739344596862793 6.112689971923828 L 8.578783988952637 9.665240287780762 L 5.429004192352295 7.805890083312988 L 2.301824569702148 9.612119674682617 L 3.108104228973389 6.061830043792725 L 0.365234375 3.678580284118652 L 3.997284412384033 3.369630336761475 L 5.404884338378906 0 Z",
  stroke: "none",
  fill: "#5f7278"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_350",
  "data-name": "Rectangle 350",
  transform: "translate(13 -7)",
  fill: "none",
  stroke: "#5f7278",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 16,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 7,
  height: 15,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_352",
  "data-name": "Rectangle 352",
  transform: "translate(24 -3)",
  fill: "none",
  stroke: "#5f7278",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 12,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 7,
  height: 11,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_351",
  "data-name": "Rectangle 351",
  transform: "translate(2 -3)",
  fill: "none",
  stroke: "#5f7278",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 12,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 7,
  height: 11,
  fill: "none"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcRatings);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_ratings.8d14147daa362cd830a8b20cca35b918.svg";